import { pick } from 'ramda';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

import * as actions from '../store/actions';

export const useBalanceAlert = () => {
    const dispatch = useDispatch();
    const { balance, isLoggedIn } = useUserSelector(pick(['balance', 'isLoggedIn']));
    const {
        lowBalanceLimits,
        lowBalanceAlertEnabled,
        lowBalanceAlertWcId
    } = useAppSelector(pick([
        'lowBalanceLimits',
        'lowBalanceAlertEnabled',
        'lowBalanceAlertWcId'
    ]));

    useEffect(() => {
        const { balances } = balance || {};

        if (!isLoggedIn || !lowBalanceAlertEnabled || !balances) {
            return;
        }

        const casinoGamingBalance = balances.casino_gaming_balance;
        const userLimit = lowBalanceLimits.find(limit => limit.currency === casinoGamingBalance.currencyCode);
        const lowBalanceHighlight = Boolean(userLimit?.amount >= casinoGamingBalance.amount);
        const showLowBalancePopup = lowBalanceHighlight && Boolean(lowBalanceAlertWcId);
        const lowBalanceCheckData = { lowBalanceHighlight, showLowBalancePopup };

        dispatch(actions.userSetAttributesAction(lowBalanceCheckData));

        // Propagate to listen from admin (e.g. WC, tags)
        publicEventsAPIService.trigger('user:lowBalanceCheck', lowBalanceCheckData);
    }, [isLoggedIn, dispatch, balance, lowBalanceAlertEnabled, lowBalanceLimits, lowBalanceAlertWcId]);
};
